// This file is generated by pnpm icons:generate. Do not edit.

import {LikeRepost_Stroke2_Corner2_Rounded as CanonicalLikeRepost_Stroke2_Corner2_Rounded} from './LikeRepost'
import {createSinglePathSVG} from './TEMPLATE'

export const Heart2_Filled_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M22.5 9.563c0 6.562-9.73 11.874-10.145 12.093a.75.75 0 0 1-.71 0C11.23 21.436 1.5 16.125 1.5 9.563A5.82 5.82 0 0 1 7.313 3.75c1.935 0 3.63.833 4.687 2.24 1.057-1.407 2.752-2.24 4.688-2.24A5.82 5.82 0 0 1 22.5 9.563Z',
  viewBox: '0 0 24 24',
  glyph: 'Heart2_Filled_Stroke2_Corner0_Rounded',
})

export const Heart2_Stroke1_Corner0_Rounded = createSinglePathSVG({
  path: 'M16.688 3.75c-1.936 0-3.631.833-4.688 2.24-1.057-1.407-2.752-2.24-4.687-2.24A5.82 5.82 0 0 0 1.5 9.563c0 6.562 9.73 11.874 10.145 12.093a.75.75 0 0 0 .71 0c.415-.22 10.145-5.531 10.145-12.093a5.82 5.82 0 0 0-5.812-5.813ZM12 20.138c-1.712-.998-9-5.542-9-10.576A4.32 4.32 0 0 1 7.313 5.25c1.823 0 3.354.971 3.993 2.531a.75.75 0 0 0 1.388 0c.64-1.563 2.17-2.531 3.994-2.531A4.32 4.32 0 0 1 21 9.563c0 5.025-7.29 9.576-9 10.575Z',
  viewBox: '0 0 24 24',
  glyph: 'Heart2_Stroke1_Corner0_Rounded',
})

export const Heart2_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M16.688 3.75c-1.936 0-3.631.833-4.688 2.24-1.057-1.407-2.752-2.24-4.687-2.24A5.82 5.82 0 0 0 1.5 9.563c0 6.562 9.73 11.874 10.145 12.093a.75.75 0 0 0 .71 0c.415-.22 10.145-5.531 10.145-12.093a5.82 5.82 0 0 0-5.812-5.813ZM12 20.138c-1.712-.998-9-5.542-9-10.576A4.32 4.32 0 0 1 7.313 5.25c1.823 0 3.354.971 3.993 2.531a.75.75 0 0 0 1.388 0c.64-1.563 2.17-2.531 3.994-2.531A4.32 4.32 0 0 1 21 9.563c0 5.025-7.29 9.576-9 10.575Z',
  viewBox: '0 0 24 24',
  glyph: 'Heart2_Stroke2_Corner0_Rounded',
})

/** @deprecated Import LikeRepost_Stroke2_Corner2_Rounded from `#/components/icons/LikeRepost` instead. */
export const LikeRepost_Stroke2_Corner2_Rounded =
  CanonicalLikeRepost_Stroke2_Corner2_Rounded
